import Style from './InsuranceLandingPage.style';

export const InsuranceLandingPage = ({ children, className }) => {
  return <Style className={`insuranceCooperationLandingPage ${className}`}>{children}</Style>;
};
